import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BookOpen, Download } from "lucide-react";
import { API, client, formatApiError } from "@/lib/api";

export default function DownloadPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { client.get(`/download/${token}`).then(r => setInfo(r.data)).catch(e => setError(formatApiError(e, "Tautan tidak valid."))); }, [token]);
  return <main className="download-page">
    <section className="auth-card download-card" data-testid="download-page">
      <div className="brand-line"><BookOpen size={20}/> <b>Lapak Digitals</b></div>
      {error && <><h2>Tautan tidak dapat dipakai</h2><div className="error" data-testid="download-error">{error}</div></>}
      {!error && !info && <p className="muted">Memeriksa tautan…</p>}
      {info && <>
        <p className="eyebrow" style={{ marginTop: 48 }}>{info.store_name}</p>
        <h2 style={{ marginTop: 0 }} data-testid="download-product-name">{info.product_name}</h2>
        <p className="muted">Halo {info.buyer_name}, e-book ini adalah hak Anda dan dapat diunduh ulang kapan saja.</p>
        {info.file_available
          ? <a className="primary-button" data-testid="download-file-button" href={`${API}/download/${token}/file`}><Download size={16}/> Unduh {info.file_name}</a>
          : <div className="error" data-testid="download-unavailable">File e-book belum diunggah penjual. Hubungi penjual.</div>}
        <p className="helper">Jangan bagikan tautan ini. Siapa pun yang memiliki tautan dapat mengunduh e-book Anda.</p>
      </>}
    </section>
  </main>;
}
